import { API_ENDPOINTS } from '@/constants';
import type {
  GetSuggestionByIdOutputDTO,
  GetSuggestionTagsOutputDTO,
  GetSuggestionsForCallOutputDTO,
} from '@/types/dynamicSuggestion';
import type { ApiBuilder } from './types';

export type GetDynamicSuggestionsForCallArgs = {
  contactId: string;
  tags?: number[];
};

function buildTagsQuery(tags: number[] | undefined): string {
  if (!tags?.length) return '';
  const params = new URLSearchParams();
  for (const tag of tags) {
    params.append('tags', String(tag));
  }
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export const dynamicSuggestionApi = (builder: ApiBuilder) => ({
  getDynamicSuggestionTags: builder.query<GetSuggestionTagsOutputDTO, void>({
    query: () => ({
      url: API_ENDPOINTS.DYNAMIC_SUGGESTION.TAGS,
      method: 'GET',
    }),
    providesTags: ['DynamicSuggestion'],
  }),

  getDynamicSuggestionsForCall: builder.query<
    GetSuggestionsForCallOutputDTO,
    GetDynamicSuggestionsForCallArgs
  >({
    query: ({ contactId, tags = [] }) => ({
      url: `${API_ENDPOINTS.DYNAMIC_SUGGESTION.FOR_CALL}/${encodeURIComponent(contactId)}${buildTagsQuery(tags)}`,
      method: 'GET',
    }),
    providesTags: (_result, _error, { contactId }) => [
      { type: 'DynamicSuggestion', id: contactId },
    ],
  }),

  getDynamicSuggestionById: builder.query<GetSuggestionByIdOutputDTO, string>({
    query: id => ({
      url: `${API_ENDPOINTS.DYNAMIC_SUGGESTION.BASE}/${encodeURIComponent(id)}`,
      method: 'GET',
    }),
    providesTags: (_result, _error, id) => [{ type: 'DynamicSuggestion', id }],
  }),
});
